import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { VERIFY_EMAIL_MUTATION } from 'graphql/auth/mutations';
import EmailVerificationSuccess from 'views/email-verification/EmailVerificationSuccess';
import EmailVerificationFailed from 'views/email-verification/EmailVerificationFailed.';
import Loader from 'components/Loader';

const EmailVerification = () => {
  const location = useLocation();
  const [verificationResult, setVerificationResult] = useState(null);
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [verifyEmail] = useMutation(VERIFY_EMAIL_MUTATION);

  useEffect(() => {
    console.log('=== FRONTEND: EmailVerification useEffect triggered ===');
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    console.log('Token from URL:', token);

    if (!token) {
      console.log('No token found in URL');
      setVerificationResult('failed');
      setErrorMessage('Verification token is missing from the URL. Please use the link from your email.');
      return;
    }

    console.log('Calling verifyEmail mutation with token:', token);
    setLoaderOpen(true);
    verifyEmail({ variables: { input: { token } } })
      .then(result => {
        console.log('Mutation result:', result);
        if (result.data?.verifyEmail === 'Email verification successful.') {
          console.log('Verification successful!');
          setVerificationResult('success');
        } else {
          console.log('Verification failed - unexpected response:', result.data?.verifyEmail);
          setVerificationResult('failed');
          setErrorMessage('Email verification was not successful. The link may be invalid or expired.');
        }
        setLoaderOpen(false);
      })
      .catch(error => {
        console.error('Email verification mutation error:', error);
        setLoaderOpen(false);
        setVerificationResult('failed');
        
        if (error.graphQLErrors && error.graphQLErrors.length > 0) {
          const errorMsg = error.graphQLErrors[0]?.message;
          console.error('GraphQL error:', errorMsg);
          setErrorMessage(errorMsg || 'Email verification failed. The link may be invalid or expired.');
        } else if (error.networkError) {
          console.error('Network error:', error.networkError);
          setErrorMessage('Network error. Please check your internet connection and try again.');
        } else {
          console.error('Unknown error:', error);
          setErrorMessage('Email verification failed. The link may be invalid, expired, or already used.');
        }
      });
  }, [location.search, verifyEmail]);

  if (loaderOpen) {
    return <Loader loaderOpen={loaderOpen} setLoaderOpen={setLoaderOpen} />;
  }

  if (verificationResult === 'success') {
    return <EmailVerificationSuccess />;
  }

  if (verificationResult === 'failed') {
    return <EmailVerificationFailed errorMessage={errorMessage} />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <p className="text-gray-600">Processing verification...</p>
      </div>
    </div>
  );
};

export default EmailVerification;
